export const ACTION_CODE = 'SERVICES' + '_ACTION';
